import { useTrackingManager } from '../TrackingManagerContext.js';
const useRequiredCategories = () => {
  const _useTrackingManager = useTrackingManager(),
    config = _useTrackingManager.config;
  return config.categories.filter(c => c.required).reduce((prev, v) => [...prev, v.id], []);
};
export { useRequiredCategories as default };
//# sourceMappingURL=useRequiredCategories.js.map
